import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownMenu, Icon } from '@pwc/pwc-deals-ui';
import useSortingDropdownNone, {
  I18N_KEY_BY_API_PARAMETER,
  optionDetails as optionsDetailsNone,
} from '../../utils/useSortingDropdownNone.ts';
import './AnalysisGroupsSorting.scss';
import {
  saveUserPreferences,
  SORT_SETTING_KEY,
} from '../../../../common/services/userPreferencesProjectService';

const AnalysisGroupsSorting = ({
  projectId,
  sortingType,
  orderAscRef,
  tags,
  sortBy,
  pageRef,
  sortingCallback,
  permissions,
  userPreference,
  preferredSortIndexRef,
}) => {
  const { hasPermission } = permissions;

  const { options, selectedOption } = useSortingDropdownNone(
    sortingCallback,
    pageRef,
    orderAscRef,
    tags,
    projectId,
    sortingType,
    userPreference,
    preferredSortIndexRef,
    sortBy
  );

  let optionsFilteredByPermission = options;

  // updatedBy and state shouldn't be displayed for client and pwc ready-only users
  if (!hasPermission) {
    optionsFilteredByPermission = options.filter(
      (option) =>
        option.text !== optionsDetailsNone.updatedBy.text &&
        option.text !== optionsDetailsNone.state.text
    );
  }

  const onClickHandler = () => {
    orderAscRef.current = !orderAscRef.current;
    pageRef.current = 0;
    sortingCallback(tags, sortBy);
    saveUserPreferences(
      projectId,
      SORT_SETTING_KEY,
      `${sortingType}-${sortBy}-${orderAscRef.current ? 'asc' : 'desc'}`
    );
  };

  const className =
    selectedOption.toLowerCase() === 'title' ||
    selectedOption.toLowerCase() === 'state'
      ? 'analysis-groups-sorting-primary'
      : 'analysis-groups-sorting';

  const { t } = useTranslation();

  const optionsI18n = [...optionsFilteredByPermission].map((option) => {
    option.text = t(option.displayTextKey);
    return option;
  });

  const selectedOptionDisplayText = t(
    I18N_KEY_BY_API_PARAMETER[selectedOption]
  );

  return (
    <div className={className} data-testid={sortingType}>
      <Icon name="sort" className="analysis-groups-sorting__sort-icon" />
      <span className="analysis-groups-sorting__title" data-testid="sortBy">
        {t('sortBy')}
      </span>

      <Icon
        name={orderAscRef.current ? 'sort-arrow-asc' : 'sort-arrow-desc'}
        className="analysis-groups-sorting__order-icon fill icon-orange"
        onClick={onClickHandler}
        data-testid="sortIcon"
      />
      <DropdownMenu title={selectedOptionDisplayText} items={optionsI18n} />
    </div>
  );
};

export default AnalysisGroupsSorting;
